export type ToastType = "success" | "error" | "info" | "warning";

interface ToastMessage {
  type: ToastType;
  message: string;
}

export const toastMessages: Record<
  number | "default" | "noConnection" | "unreachable",
  { type: ToastType; message: string }
> = {
  // No connection (null / undefined response)
  noConnection: { type: "error", message: "Keine Verbindung zum Server." },

  // Success
  200: { type: "success", message: "Vorgang erfolgreich." },
  201: { type: "success", message: "Erstellt." },
  202: { type: "info", message: "Anfrage akzeptiert und wird verarbeitet." },
  204: { type: "info", message: "Erfolgreich — keine Inhalte zurückgegeben." },

  // Client errors
  401: {
    type: "error",
    message: "Nicht autorisiert. Bitte melde dich an.",
  },
  403: {
    type: "error",
    message: "Zugriff verweigert. Du hast keine Berechtigung.",
  },
  404: { type: "warning", message: "Nicht gefunden." },

  // Server errors
  500: {
    type: "error",
    message: "Interner Serverfehler. Bitte später erneut versuchen.",
  },
  502: { type: "error", message: "Fehlerhaftes Gateway." },
  503: {
    type: "error",
    message: "Dienst nicht verfügbar. Bitte später versuchen.",
  },
  504: { type: "error", message: "Gateway-Zeitüberschreitung." },

  // Defaults
  default: { type: "error", message: "Etwas ist schiefgelaufen." },

  unreachable: {
    type: "error",
    message: "Server nicht erreichbar. Bitte versuche es später.",
  },
};
